export const categories = [
  { id: '1', name: '全部', slug: 'all', count: 128 },
  { id: '2', name: '动作片', slug: 'action', count: 35 },
  { id: '3', name: '喜剧片', slug: 'comedy', count: 28 },
  { id: '4', name: '科幻片', slug: 'scifi', count: 22 },
  { id: '5', name: '爱情片', slug: 'romance', count: 18 },
  { id: '6', name: '恐怖片', slug: 'horror', count: 15 },
  { id: '7', name: '动画片', slug: 'animation', count: 20 },
  { id: '8', name: '剧情片', slug: 'drama', count: 30 },
  { id: '9', name: '战争片', slug: 'war', count: 12 },
  { id: '10', name: '纪录片', slug: 'documentary', count: 10 },
];

export const movies = [
  {
    id: '1',
    title: '流浪地球2',
    year: 2023,
    category: 'scifi',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Cinematic%20movie%20poster%20featuring%20a%20futuristic%20space%20station%20with%20Earth%20in%20the%20background%2C%20dramatic%20lighting%2C%20epic%20sci-fi%20atmosphere%2C%20dark%20and%20warm%20tones%2C%20professional%20film%20poster%20style%20with%20Chinese%20typography%20space%2C%20clean%20composition%2C%20high%20contrast&width=600&height=800&seq=movie-poster-01&orientation=portrait',
    description: '太阳即将毁灭，人类在地球表面建造出巨大的推进器，寻找新的家园。然而宇宙之路危机四伏，为了拯救地球，流浪地球时代的年轻人再次挺身而出，展开争分夺秒的生死之战。',
    director: '郭帆',
    actors: ['吴京', '刘德华', '李雪健', '沙溢'],
    duration: '173分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '2',
    title: '满江红',
    year: 2023,
    category: 'drama',
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Historical%20Chinese%20drama%20movie%20poster%20set%20in%20ancient%20China%2C%20warriors%20in%20traditional%20armor%2C%20dark%20moody%20atmosphere%20with%20red%20accents%2C%20cinematic%20lighting%2C%20professional%20film%20poster%20design%2C%20dramatic%20composition&width=600&height=800&seq=movie-poster-02&orientation=portrait',
    description: '南宋绍兴年间，岳飞死后四年，秦桧率兵与金国会谈。会谈前夜，金国使者死在宰相驻地，所携密信也不翼而飞。一个小兵与亲兵营副统领机缘巧合被裹挟进这巨大阴谋之中。',
    director: '张艺谋',
    actors: ['沈腾', '易烊千玺', '张译', '雷佳音'],
    duration: '159分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '3',
    title: '速度与激情10',
    year: 2023,
    category: 'action',
    rating: 7.2,
    image: 'https://readdy.ai/api/search-image?query=Action%20movie%20poster%20with%20fast%20cars%20racing%20through%20city%20streets%2C%20explosive%20orange%20and%20red%20color%20palette%2C%20dynamic%20motion%20blur%2C%20cinematic%20lighting%2C%20professional%20Hollywood%20blockbuster%20poster%20style%2C%20intense%20atmosphere&width=600&height=800&seq=movie-poster-03&orientation=portrait',
    description: '在多年执行任务的过程中，唐老大和他的家人面临过各种各样的对手。但这一次，他们面对的是但丁——那个曾经被他们击败的毒枭之子，一个发誓要复仇的危险人物。',
    director: '路易斯·莱特里尔',
    actors: ['范·迪塞尔', '米歇尔·罗德里格兹', '杰森·莫玛'],
    duration: '141分钟',
    quality: 'HD',
    isNew: true,
    isHot: true,
  },
  {
    id: '4',
    title: '独行月球',
    year: 2022,
    category: 'comedy',
    rating: 7.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20comedy%20sci-fi%20movie%20poster%20featuring%20an%20astronaut%20alone%20on%20the%20moon%2C%20humorous%20tone%2C%20Earth%20visible%20in%20background%2C%20warm%20lighting%2C%20playful%20composition%2C%20cinematic%20quality%2C%20clean%20design&width=600&height=800&seq=movie-poster-04&orientation=portrait',
    description: '人类为抵御小行星的撞击，部署了月盾计划。陨石提前来袭，全员紧急撤离时，维修工独孤月因为意外错过了撤离通知，一个人落在了月球。不料月盾计划失败，独孤月成为了"宇宙最后的人类"。',
    director: '张吃鱼',
    actors: ['沈腾', '马丽', '黄才伦'],
    duration: '122分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '5',
    title: '孤注一掷',
    year: 2023,
    category: 'drama',
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Suspenseful%20Chinese%20crime%20drama%20movie%20poster%2C%20dark%20underground%20setting%20with%20computer%20screens%2C%20tense%20atmosphere%2C%20red%20and%20dark%20tones%2C%20cinematic%20thriller%20style%2C%20professional%20film%20poster%20design&width=600&height=800&seq=movie-poster-05&orientation=portrait',
    description: '程序员潘生和模特安娜被海外高薪招聘吸引，却意外落入境外诈骗工厂的陷阱。为了离开，两人准备向赌徒阿天和其女友小雨下手，从他们身上套现完成业绩。',
    director: '申奥',
    actors: ['张艺兴', '金晨', '咏梅', '王传君'],
    duration: '130分钟',
    quality: '4K',
    isNew: true,
    isHot: true,
  },
  {
    id: '6',
    title: '铃芽之旅',
    year: 2023,
    category: 'animation',
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Japanese%20anime%20movie%20poster%20style%2C%20beautiful%20girl%20with%20a%20chair%20traveling%20through%20mystical%20doors%2C%20soft%20dreamy%20atmosphere%2C%20pink%20and%20blue%20sky%2C%20cinematic%20animation%20art%20style%2C%20clean%20composition&width=600&height=800&seq=movie-poster-06&orientation=portrait',
    description: '生活在日本九州乡间的17岁少女铃芽，遇见了为寻找"门"而踏上旅途的青年。追随着青年的脚步，铃芽来到了山上一片废墟之地，在这里她发现了一扇古老的门。',
    director: '新海诚',
    actors: ['原菜乃华', '松村北斗', '深津绘里'],
    duration: '122分钟',
    quality: 'HD',
    isNew: true,
    isHot: false,
  },
  {
    id: '7',
    title: '消失的她',
    year: 2023,
    category: 'drama',
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Mystery%20thriller%20movie%20poster%20with%20a%20couple%20in%20tropical%20setting%2C%20dark%20secrets%20theme%2C%20deep%20blue%20and%20warm%20tones%2C%20suspenseful%20cinematic%20atmosphere%2C%20professional%20film%20poster%20design&width=600&height=800&seq=movie-poster-07&orientation=portrait',
    description: '何非的妻子李木子在结婚周年旅行中离奇消失，在他苦寻无果之时妻子再次现身，何非却坚持眼前的陌生女人并非妻子。夫妻二人似乎都有着不可告人的秘密。',
    director: '崔睿 / 刘翔',
    actors: ['朱一龙', '倪妮', '文咏珊'],
    duration: '121分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '8',
    title: '封神第一部',
    year: 2023,
    category: 'action',
    rating: 8.2,
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20fantasy%20movie%20poster%20with%20ancient%20warriors%20and%20mythological%20creatures%2C%20grand%20battle%20scene%2C%20golden%20and%20bronze%20color%20tones%2C%20cinematic%20historical%20epic%20style%2C%20dramatic%20lighting&width=600&height=800&seq=movie-poster-08&orientation=portrait',
    description: '商王殷寿暴虐无道，西伯侯之子姬发觉醒。昆仑仙人姜子牙携"封神榜"下山，寻找天下共主以救苍生。一场横跨人、仙、妖三界的封神大战即将展开。',
    director: '乌尔善',
    actors: ['费翔', '李雪健', '黄渤', '于适'],
    duration: '148分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '9',
    title: '人生大事',
    year: 2022,
    category: 'drama',
    rating: 7.7,
    image: 'https://readdy.ai/api/search-image?query=Heartwarming%20Chinese%20drama%20movie%20poster%20about%20funeral%20director%20and%20a%20little%20girl%2C%20warm%20emotional%20tone%2C%20urban%20Chinese%20setting%2C%20soft%20natural%20lighting%2C%20cinematic%20quality%2C%20touching%20atmosphere&width=600&height=800&seq=movie-poster-09&orientation=portrait',
    description: '殡葬师莫三妹在刑满释放不久后的一次出殡中，遇到了孤儿武小文。小文的出现意外地改变了莫三妹对职业和生活的态度。',
    director: '刘江江',
    actors: ['朱一龙', '杨恩又', '王戈'],
    duration: '112分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '10',
    title: '哥斯拉大战金刚2',
    year: 2024,
    category: 'action',
    rating: 7.4,
    image: 'https://readdy.ai/api/search-image?query=Epic%20monster%20movie%20poster%20featuring%20giant%20Godzilla%20and%20King%20Kong%20facing%20off%2C%20city%20destruction%20background%2C%20fiery%20orange%20and%20red%20explosive%20tones%2C%20cinematic%20blockbuster%20style%2C%20dramatic%20lighting&width=600&height=800&seq=movie-poster-10&orientation=portrait',
    description: '继上一次的怪兽高燃对战之后，金刚和哥斯拉将再度联手对抗一个潜伏在世界中的巨大威胁——刀疤王。这次他们将深入探索地心世界，揭开巨兽起源的秘密。',
    director: '亚当·温加德',
    actors: ['丽贝卡·豪尔', '丹·史蒂文斯', '布莱恩·泰里·亨利'],
    duration: '115分钟',
    quality: '4K',
    isNew: true,
    isHot: true,
  },
  {
    id: '11',
    title: '年会不能停',
    year: 2023,
    category: 'comedy',
    rating: 8.1,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20office%20comedy%20movie%20poster%2C%20corporate%20setting%20with%20humorous%20characters%2C%20bright%20office%20lighting%2C%20playful%20atmosphere%2C%20professional%20Chinese%20film%20poster%20style%2C%20clean%20modern%20design&width=600&height=800&seq=movie-poster-11&orientation=portrait',
    description: '钳工胡建林阴差阳错被调入集团总部，从"工厂"到"大厂"，从"蓝领"变"金领"。他与人事经理马杰被裹挟在"错调"事件中，人事经理马杰诚惶诚恐，为保饭碗被迫为其隐瞒周旋。',
    director: '董润年',
    actors: ['大鹏', '白客', '庄达菲'],
    duration: '117分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '12',
    title: '热辣滚烫',
    year: 2024,
    category: 'comedy',
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=Inspirational%20Chinese%20comedy%20drama%20movie%20poster%20about%20boxing%20transformation%2C%20warm%20motivational%20tone%2C%20gym%20setting%2C%20soft%20golden%20lighting%2C%20cinematic%20quality%2C%20clean%20empowering%20design&width=600&height=800&seq=movie-poster-12&orientation=portrait',
    description: '乐莹是一个善良的女孩，但毕业后一直宅在家里，与外界隔离。在遭遇一系列挫折后，她偶然接触到拳击这项运动，从此踏上了一条重塑自我、热血滚烫的人生之路。',
    director: '贾玲',
    actors: ['贾玲', '雷佳音', '张小斐'],
    duration: '129分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '13',
    title: '周处除三害',
    year: 2023,
    category: 'action',
    rating: 8.4,
    image: 'https://readdy.ai/api/search-image?query=Taiwanese%20crime%20action%20movie%20poster%2C%20intense%20gangster%20theme%2C%20dark%20urban%20night%20setting%2C%20red%20and%20black%20color%20palette%2C%20gritty%20cinematic%20style%2C%20professional%20Asian%20film%20poster%20design&width=600&height=800&seq=movie-poster-13&orientation=portrait',
    description: '通缉犯陈桂林生命将尽，却发现自己在通缉榜上只排名第三，他决心查出前两名通缉犯的下落，并将他们一一除掉。陈桂林以为自己已成为当代的周处除三害，却没想到永远参不透的贪嗔痴，才是人生终要面对的罪与罚。',
    director: '黄精甫',
    actors: ['阮经天', '袁富华', '陈以文'],
    duration: '134分钟',
    quality: '4K',
    isNew: true,
    isHot: true,
  },
  {
    id: '14',
    title: '芭比',
    year: 2023,
    category: 'comedy',
    rating: 7.3,
    image: 'https://readdy.ai/api/search-image?query=Pink%20vibrant%20Barbie%20movie%20poster%20in%20Hollywood%20style%2C%20fantasy%20dream%20world%2C%20bright%20colorful%20atmosphere%2C%20playful%20cinematic%20design%2C%20professional%20film%20poster%20with%20clean%20composition&width=600&height=800&seq=movie-poster-14&orientation=portrait',
    description: '在梦幻的芭比乐园里，各种芭比和肯每天都过着童话般完美的生活。但是某一天，芭比发现自己的生活开始有了变化，她不得不前往真实世界探寻真相。',
    director: '格蕾塔·葛韦格',
    actors: ['玛格特·罗比', '瑞恩·高斯林', '亚美莉卡·费雷拉'],
    duration: '114分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '15',
    title: '奥本海默',
    year: 2023,
    category: 'drama',
    rating: 8.8,
    image: 'https://readdy.ai/api/search-image?query=Historical%20biopic%20movie%20poster%20featuring%20scientist%20with%20nuclear%20explosion%20imagery%2C%20intense%20dramatic%20lighting%2C%20black%20and%20white%20with%20orange%20fire%20accents%2C%20cinematic%20Oscar-worthy%20style%2C%20serious%20tone&width=600&height=800&seq=movie-poster-15&orientation=portrait',
    description: '影片聚焦"原子弹之父"罗伯特·奥本海默的一生。观众将看到一个谜一般的男人，他带领团队制造出世界上第一批核武器，却因此陷入了深刻的道德困境中无法自拔。',
    director: '克里斯托弗·诺兰',
    actors: ['基里安·墨菲', '艾米莉·布朗特', '马特·达蒙'],
    duration: '180分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '16',
    title: '长安三万里',
    year: 2023,
    category: 'animation',
    rating: 8.3,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20historical%20animation%20movie%20poster%20set%20in%20Tang%20Dynasty%2C%20ancient%20Chinese%20city%20Changan%2C%20poetic%20atmosphere%2C%20warm%20golden%20tones%2C%20traditional%20Chinese%20art%20style%20blended%20with%203D%20animation%2C%20cinematic%20quality&width=600&height=800&seq=movie-poster-16&orientation=portrait',
    description: '安史之乱爆发后数年，吐蕃大军攻打西南。大唐节度使高适交战不利，长安岌岌可危。困守孤城的高适向监军回忆起自己与李白的一生往事，从开元盛世到安史之乱，两位诗人跨越数十年的情谊徐徐展开。',
    director: '谢君伟 / 邹靖',
    actors: ['杨天翔', '凌振赫', '吴俊全'],
    duration: '168分钟',
    quality: '4K',
    isNew: false,
    isHot: true,
  },
  {
    id: '17',
    title: '涉过愤怒的海',
    year: 2023,
    category: 'drama',
    rating: 7.9,
    image: 'https://readdy.ai/api/search-image?query=Dark%20psychological%20thriller%20movie%20poster%20with%20stormy%20ocean%20and%20lonely%20figure%2C%20cold%20blue%20and%20gray%20tones%2C%20intense%20emotional%20atmosphere%2C%20cinematic%20art%20house%20style%2C%20professional%20film%20poster&width=600&height=800&seq=movie-poster-17&orientation=portrait',
    description: '老金为供女儿金丽娜留学终日捕鱼，却换来女儿身中17刀离奇身亡的死讯。最大嫌疑人则指向她的男友李苗苗。愤怒的老金踏上跨海寻仇之路。',
    director: '曹保平',
    actors: ['黄渤', '周迅', '祖峰'],
    duration: '144分钟',
    quality: '4K',
    isNew: false,
    isHot: false,
  },
  {
    id: '18',
    title: '巨齿鲨2：深渊',
    year: 2023,
    category: 'action',
    rating: 6.8,
    image: 'https://readdy.ai/api/search-image?query=Underwater%20monster%20action%20movie%20poster%20with%20giant%20shark%2C%20deep%20ocean%20setting%2C%20dark%20blue%20water%20with%20suspenseful%20atmosphere%2C%20cinematic%20blockbuster%20style%2C%20professional%20Hollywood%20poster%20design&width=600&height=800&seq=movie-poster-18&orientation=portrait',
    description: '乔纳斯·泰勒与科学家张九溟双雄联手，进入海底7000米深渊执行探索任务。他们意外遭遇史前巨兽海洋霸主巨齿鲨群的攻击，还将对战凶猛危险的远古怪兽群。',
    director: '本·维特利',
    actors: ['杰森·斯坦森', '吴京', '蔡书雅'],
    duration: '119分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '19',
    title: '一闪一闪亮星星',
    year: 2023,
    category: 'romance',
    rating: 7.1,
    image: 'https://readdy.ai/api/search-image?query=Romantic%20Chinese%20youth%20movie%20poster%20with%20starry%20night%20sky%2C%20young%20couple%20silhouette%2C%20warm%20dreamy%20atmosphere%2C%20soft%20pink%20and%20purple%20tones%2C%20cinematic%20romantic%20style%2C%20clean%20composition&width=600&height=800&seq=movie-poster-19&orientation=portrait',
    description: '张万森计划在高考后向暗恋已久的女生林北星表白，但突发的演唱会事故让一切变成了无可挽回的悲剧。没想到的是，痛苦无助的张万森竟意外重启了这个夏天。',
    director: '陈小明 / 章攀',
    actors: ['屈楚萧', '张佳宁', '傅菁'],
    duration: '107分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '20',
    title: '三大队',
    year: 2023,
    category: 'drama',
    rating: 8.0,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20crime%20police%20drama%20movie%20poster%2C%20detective%20team%20in%20urban%20night%2C%20serious%20realistic%20tone%2C%20dark%20moody%20lighting%2C%20cinematic%20thriller%20style%2C%20professional%20Asian%20film%20poster%20design&width=600&height=800&seq=movie-poster-20&orientation=portrait',
    description: '刑侦大队队长程兵带领的三大队在办理一起恶性案件的过程中导致嫌犯之一意外死亡，被判入狱。出狱后，他坚持以普通人身份继续追踪在逃嫌犯。',
    director: '戴墨',
    actors: ['张译', '李晨', '魏晨', '曹炳琨'],
    duration: '132分钟',
    quality: '4K',
    isNew: false,
    isHot: false,
  },
  {
    id: '21',
    title: '龙与地下城',
    year: 2023,
    category: 'action',
    rating: 7.6,
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20adventure%20movie%20poster%20with%20dragon%20and%20warriors%2C%20magical%20medieval%20setting%2C%20epic%20cinematic%20atmosphere%2C%20warm%20golden%20and%20green%20tones%2C%20professional%20Hollywood%20fantasy%20poster%20style&width=600&height=800&seq=movie-poster-21&orientation=portrait',
    description: '一个迷人的盗贼和一群不太可能的冒险家为了找回一件失落的圣物而进行一场史诗般的抢劫，但当他们与错误的人发生冲突时，事情就危险地出错了。',
    director: '约翰·弗朗西斯·戴利',
    actors: ['克里斯·派恩', '米歇尔·罗德里格兹', '雷吉-让·佩吉'],
    duration: '134分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
  {
    id: '22',
    title: '志愿军：雄兵出击',
    year: 2023,
    category: 'war',
    rating: 7.8,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20war%20movie%20poster%20depicting%20Korean%20War%20battle%20scene%2C%20soldiers%20in%20winter%20combat%2C%20epic%20patriotic%20tone%2C%20cold%20snowy%20atmosphere%2C%20cinematic%20historical%20war%20style%2C%20dramatic%20lighting&width=600&height=800&seq=movie-poster-22&orientation=portrait',
    description: '1949年建国初期，新中国面临"内忧外患"局面。朝鲜内战爆发以来，美军屡在中朝边境挑衅，平民惨遭轰炸。为了维护来之不易的和平，中国人民志愿军入朝作战。',
    director: '陈凯歌',
    actors: ['唐国强', '王砚辉', '刘劲', '辛柏青'],
    duration: '141分钟',
    quality: '4K',
    isNew: false,
    isHot: false,
  },
  {
    id: '23',
    title: '莫斯科行动',
    year: 2023,
    category: 'action',
    rating: 7.5,
    image: 'https://readdy.ai/api/search-image?query=Chinese%20action%20thriller%20movie%20poster%20set%20in%20Moscow%2C%20train%20heist%20theme%2C%20cold%20winter%20Russian%20setting%2C%20red%20and%20dark%20tones%2C%20cinematic%20crime%20action%20style%2C%20professional%20film%20poster&width=600&height=800&seq=movie-poster-23&orientation=portrait',
    description: '90年代初，苏联解体后俄罗斯经济濒临崩溃。以苗青山为首的悍匪团伙在K3次北京至莫斯科的国际列车上进行了一系列丧心病狂的连环洗劫。中国警察崔振海带领秘密小队深入陌生国度莫斯科展开跨境追捕。',
    director: '邱礼涛',
    actors: ['张涵予', '刘德华', '黄轩'],
    duration: '128分钟',
    quality: '4K',
    isNew: true,
    isHot: false,
  },
  {
    id: '24',
    title: '名侦探柯南：黑铁的鱼影',
    year: 2023,
    category: 'animation',
    rating: 7.3,
    image: 'https://readdy.ai/api/search-image?query=Detective%20Conan%20anime%20movie%20poster%20with%20ocean%20and%20submarine%20theme%2C%20mystery%20atmosphere%2C%20dark%20blue%20underwater%20setting%2C%20Japanese%20anime%20cinematic%20style%2C%20clean%20dynamic%20composition&width=600&height=800&seq=movie-poster-24&orientation=portrait',
    description: '故事发生在东京八丈岛近海，一座将全球各地警方监控摄像头连接起来的海洋设施"太平洋浮标"即将启动。柯南与少年侦探团受邀前往，却意外卷入了一场黑暗组织的惊天阴谋。',
    director: '立川让',
    actors: ['高山南', '山崎和佳奈', '小山力也'],
    duration: '109分钟',
    quality: 'HD',
    isNew: false,
    isHot: false,
  },
];